// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetPointOfSalesResponse, GetPointOfSales1Response, AddPointOfSaleData, AddPointOfSaleResponse, SetGoogleReviewUrlsData, SetGoogleReviewUrlsResponse, GetPointOfSaleProfileResponse, GetPointOfSaleTillsData, GetPointOfSaleTillsResponse, AddTillData, AddTillResponse, UpdatePointOfSaleData, UpdatePointOfSaleResponse, GetPointOfSaleByIdData, GetPointOfSaleByIdResponse, SetupPartnerIntegrationData, SetupPartnerIntegrationResponse2, GetPartnerIntegrationData, GetPartnerIntegrationResponse, GetReceiptsReportData, GetReceiptsReportResponse2, ClaimReceiptData, ClaimReceiptResponse2, GetReceiptByIdResponse, RetrieveReceiptBySmsData, RetrieveReceiptBySmsResponse, GetUserReceiptsResponse, ClaimTillDemoReceiptResponse, ClaimTillLastReceiptData, ClaimTillLastReceiptResponse, AddTillReceiptData, AddTillReceiptResponse, ClaimDemoReceiptResponse, ClaimReceiptV1Data, ClaimReceiptV1Response, GetReceiptByIdV1Data, GetReceiptByIdV1Response, InspectReceiptData, InspectReceiptResponse, UploadDocumentData, UploadDocumentResponse, SendReceiptData, ScanReceiptQrCodeResponse2, ScanTillQrCodeResponse2, ScanGameQrCodeData, ScanGameQrCodeResponse2, SubmitPosReviewData, SubmitEmbasementData, RecordRedirectionLinkClickData, RecordPromotionClickData, PlayScratchGameData, PlayScratchGameResponse, CollectScratchGamePrizeData, CollectScratchGamePrizeResponse, RegisterData, RegisterResponse, LoginData, LoginResponse2, GoogleLoginData, UpgradeFromJwtV1Response2, UpgradeToApiKeyData, UpgradeToApiKeyResponse2, CheckEmailAvailabilityData, CheckEmailAvailabilityResponse2, ChangePasswordData, SendResetPasswordData, ResetPasswordData, GetAuthenticatedUserResponse, UpdateAuthenticatedUserData, UpdateAuthenticatedUserResponse, GetOrganizationTillsData, GetOrganizationTillsResponse, UpdateSoftwareMetadataData, UpdateSoftwareMetadataResponse, GetTillByApiKeyData, GetTillByApiKeyResponse, GetTillApiKeyData, GetTillApiKeyResponse, RevokeTillApiKeyData, RevokeTillApiKeyResponse, RenewTillApiKeyData, RenewTillApiKeyResponse, GetTillByIdData, GetTillByIdResponse, UpdateTillData, UpdateTillResponse, FindAllFeatureFlagsResponse } from './types.gen';

export class PointsOfSaleController {
    /**
     * Get the points of sale
     * @returns PointOfSaleResponse
     * @throws ApiError
     */
    public static getPointOfSales(): CancelablePromise<GetPointOfSalesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/points-of-sale',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Get the points of sale
     * @returns PointOfSaleResponse
     * @throws ApiError
     */
    public static getPointOfSales1(): CancelablePromise<GetPointOfSales1Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/organizations/{organizationId}/points-of-sale',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Add a point of sale
     * @param data The data for the request.
     * @param data.organizationId
     * @param data.formData
     * @returns PointOfSale
     * @throws ApiError
     */
    public static addPointOfSale(data: AddPointOfSaleData): CancelablePromise<AddPointOfSaleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/organizations/{organizationId}/points-of-sale',
            path: {
                organizationId: data.organizationId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Set Google review URLs for points of sale
     * @param data The data for the request.
     * @param data.requestBody
     * @returns PointOfSaleResponse
     * @throws ApiError
     */
    public static setGoogleReviewUrls(data: SetGoogleReviewUrlsData): CancelablePromise<SetGoogleReviewUrlsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/points-of-sale/google-review',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * @returns PointOfSaleProfileResponse
     * @throws ApiError
     */
    public static getPointOfSaleProfile(): CancelablePromise<GetPointOfSaleProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/points-of-sale/{pointOfSaleId}/profile',
            errors: {
                404: 'The point of sale was not found.'
            }
        });
    }
    
    /**
     * Get the point of sale's tills
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @returns Till
     * @throws ApiError
     */
    public static getPointOfSaleTills(data: GetPointOfSaleTillsData): CancelablePromise<GetPointOfSaleTillsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/points-of-sale/{pointOfSaleId}/tills',
            path: {
                pointOfSaleId: data.pointOfSaleId
            },
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Register a till for a point of sale
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @param data.requestBody
     * @returns CreateTillResponse
     * @throws ApiError
     */
    public static addTill(data: AddTillData): CancelablePromise<AddTillResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/points-of-sale/{pointOfSaleId}/tills',
            path: {
                pointOfSaleId: data.pointOfSaleId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Update point of sale info
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @param data.formData
     * @returns PointOfSale
     * @throws ApiError
     */
    public static updatePointOfSale(data: UpdatePointOfSaleData): CancelablePromise<UpdatePointOfSaleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/points-of-sale/{pointOfSaleId}',
            path: {
                pointOfSaleId: data.pointOfSaleId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Get a point of sale
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @returns PointOfSale
     * @throws ApiError
     */
    public static getPointOfSaleById(data: GetPointOfSaleByIdData): CancelablePromise<GetPointOfSaleByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/points-of-sale/{pointOfSaleId}',
            path: {
                pointOfSaleId: data.pointOfSaleId
            },
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Setup a partner integration for a point of sale
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @param data.partner
     * @param data.requestBody
     * @returns SetupPartnerIntegrationResponse
     * @throws ApiError
     */
    public static setupPartnerIntegration(data: SetupPartnerIntegrationData): CancelablePromise<SetupPartnerIntegrationResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/points-of-sale/{pointOfSaleId}/partner-integration/{partner}/setup',
            path: {
                pointOfSaleId: data.pointOfSaleId,
                partner: data.partner
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Get the partner integration for a point of sale
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @returns PartnerIntegration
     * @throws ApiError
     */
    public static getPartnerIntegration(data: GetPartnerIntegrationData): CancelablePromise<GetPartnerIntegrationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/points-of-sale/{pointOfSaleId}/partner-integration',
            path: {
                pointOfSaleId: data.pointOfSaleId
            },
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
}

export class ReceiptsController {
    /**
     * Get receipts report
     * @param data The data for the request.
     * @param data.period
     * @param data.pointOfSaleIds
     * @returns GetReceiptsReportResponse
     * @throws ApiError
     */
    public static getReceiptsReport(data: GetReceiptsReportData = {}): CancelablePromise<GetReceiptsReportResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/receipts/report',
            query: {
                period: data.period,
                pointOfSaleIds: data.pointOfSaleIds
            },
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ReceiptResponse
     * @throws ApiError
     */
    public static claimReceipt(data: ClaimReceiptData): CancelablePromise<ClaimReceiptResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/receipts/{receiptId}/claim',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: 'The security code is invalid.',
                404: 'The receipt was not found.'
            }
        });
    }
    
    /**
     * @returns ReceiptResponse
     * @throws ApiError
     */
    public static getReceiptById(): CancelablePromise<GetReceiptByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/receipts/{receiptId}',
            errors: {
                403: 'The user is not the owner of the receipt.',
                404: 'The receipt was not found.'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ReceiptResponse
     * @throws ApiError
     */
    public static retrieveReceiptBySms(data: RetrieveReceiptBySmsData): CancelablePromise<RetrieveReceiptBySmsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/receipts/retrieve-by-sms',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'The receipt was not found.'
            }
        });
    }
    
    /**
     * List receipts for the authenticated user
     * @returns UserReceipt
     * @throws ApiError
     */
    public static getUserReceipts(): CancelablePromise<GetUserReceiptsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/user/receipts',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Claim the last receipt of a till
     * @returns ClaimReceiptResponse
     * @throws ApiError
     */
    public static claimTillDemoReceipt(): CancelablePromise<ClaimTillDemoReceiptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tills/demo/claim-last-receipt',
            errors: {
                403: '',
                409: ''
            }
        });
    }
    
    /**
     * Claim the last receipt of a till
     * @param data The data for the request.
     * @param data.tillId
     * @param data.code
     * @returns ClaimReceiptResponse
     * @throws ApiError
     */
    public static claimTillLastReceipt(data: ClaimTillLastReceiptData): CancelablePromise<ClaimTillLastReceiptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tills/{tillId}/claim-last-receipt',
            path: {
                tillId: data.tillId
            },
            query: {
                code: data.code
            },
            errors: {
                403: '',
                409: ''
            }
        });
    }
    
    /**
     * Envoyer un ticket
     * @param data The data for the request.
     * @param data.tillId Identifiant unique de la caisse
     * @param data.xApiKey Clé d'API de la caisse
     * @param data.requestBody
     * @returns ReceiptDetails
     * @throws ApiError
     */
    public static addTillReceipt(data: AddTillReceiptData): CancelablePromise<AddTillReceiptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/tills/{tillId}/receipts',
            path: {
                tillId: data.tillId
            },
            headers: {
                'X-API-Key': data.xApiKey
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Claim a demo receipt
     * @returns ClaimReceiptResponse
     * @throws ApiError
     */
    public static claimDemoReceipt(): CancelablePromise<ClaimDemoReceiptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/receipts/demo/claim',
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Claim a receipt
     * @param data The data for the request.
     * @param data.receiptId
     * @param data.code
     * @param data.claimToken
     * @returns ClaimReceiptResponse
     * @throws ApiError
     */
    public static claimReceiptV1(data: ClaimReceiptV1Data): CancelablePromise<ClaimReceiptV1Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/receipts/{receiptId}/claim',
            path: {
                receiptId: data.receiptId
            },
            query: {
                code: data.code,
                claimToken: data.claimToken
            },
            errors: {
                403: '',
                409: ''
            }
        });
    }
    
    /**
     * Get a receipt by id
     * @param data The data for the request.
     * @param data.receiptId
     * @returns ReceiptPageData
     * @throws ApiError
     */
    public static getReceiptByIdV1(data: GetReceiptByIdV1Data): CancelablePromise<GetReceiptByIdV1Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/receipts/{receiptId}',
            path: {
                receiptId: data.receiptId
            },
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Inspect a receipt
     * @param data The data for the request.
     * @param data.receiptId
     * @param data.securityHash
     * @returns ReceiptPageData
     * @throws ApiError
     */
    public static inspectReceipt(data: InspectReceiptData): CancelablePromise<InspectReceiptResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/receipts/{receiptId}/inspect',
            path: {
                receiptId: data.receiptId
            },
            query: {
                securityHash: data.securityHash
            },
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Upload a document for a receipt
     * @param data The data for the request.
     * @param data.receiptId
     * @param data.xApiKey
     * @param data.formData
     * @returns ReceiptDocument
     * @throws ApiError
     */
    public static uploadDocument(data: UploadDocumentData): CancelablePromise<UploadDocumentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/receipts/{receiptId}/documents',
            path: {
                receiptId: data.receiptId
            },
            headers: {
                'X-API-Key': data.xApiKey
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Send a receipt by SMS
     * @param data The data for the request.
     * @param data.receiptId
     * @param data.xApiKey
     * @param data.requestBody
     * @throws ApiError
     */
    public static sendReceipt(data: SendReceiptData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/receipts/{receiptId}/send',
            path: {
                receiptId: data.receiptId
            },
            headers: {
                'X-API-Key': data.xApiKey
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: ''
            }
        });
    }
    
}

export class QrCodesController {
    /**
     * @returns ScanReceiptQrCodeResponse
     * @throws ApiError
     */
    public static scanReceiptQrCode(): CancelablePromise<ScanReceiptQrCodeResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/qr-codes/receipts/{receiptId}/scan',
            errors: {
                404: 'The receipt was not found.',
                500: ''
            }
        });
    }
    
    /**
     * @returns ScanTillQrCodeResponse Either `receiptId` or `customerGameId` can be present, but never both.
     * @throws ApiError
     */
    public static scanTillQrCode(): CancelablePromise<ScanTillQrCodeResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/qr-codes/tills/{tillId}/scan',
            errors: {
                404: 'The till was not found.',
                500: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ScanGameQrCodeResponse
     * @throws ApiError
     */
    public static scanGameQrCode(data: ScanGameQrCodeData): CancelablePromise<ScanGameQrCodeResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/qr-codes/customer-game',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'The till was not found.',
                500: ''
            }
        });
    }
    
}

export class UserInteractionsController {
    /**
     * Submit a point of sale review
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static submitPosReview(data: SubmitPosReviewData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/pos-review',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                401: ''
            }
        });
    }
    
    /**
     * Submit an embasement
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static submitEmbasement(data: SubmitEmbasementData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/embasement',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                401: ''
            }
        });
    }
    
    /**
     * Record a redirection link click
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static recordRedirectionLinkClick(data: RecordRedirectionLinkClickData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/redirection-link-click',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                401: ''
            }
        });
    }
    
    /**
     * Record a promotion click
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static recordPromotionClick(data: RecordPromotionClickData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/promotion-click',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                401: ''
            }
        });
    }
    
}

export class ScratchGamesController {
    /**
     * @param data The data for the request.
     * @param data.scratchGameId
     * @returns ScratchGameResponse
     * @throws ApiError
     */
    public static playScratchGame(data: PlayScratchGameData): CancelablePromise<PlayScratchGameResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/scratch-games/{scratchGameId}/play',
            path: {
                scratchGameId: data.scratchGameId
            },
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Collect a scratch game prize
     * @param data The data for the request.
     * @param data.scratchGameId
     * @param data.requestBody
     * @returns ScratchGameResponse
     * @throws ApiError
     */
    public static collectScratchGamePrize(data: CollectScratchGamePrizeData): CancelablePromise<CollectScratchGamePrizeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/scratch-games/{scratchGameId}/collect-prize',
            path: {
                scratchGameId: data.scratchGameId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
}

export class AuthController {
    /**
     * Register a new user
     * @param data The data for the request.
     * @param data.requestBody
     * @returns RegisterUserResponse
     * @throws ApiError
     */
    public static register(data: RegisterData): CancelablePromise<RegisterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/auth/register',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Invalid inputs',
                409: 'Email address is already taken'
            }
        });
    }
    
    /**
     * Authenticate user and return JWT
     * @param data The data for the request.
     * @param data.requestBody
     * @returns LoginResponse
     * @throws ApiError
     */
    public static login(data: LoginData): CancelablePromise<LoginResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/auth/login',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Invalid credentials'
            }
        });
    }
    
    /**
     * Initiate Google OAuth flow
     * @param data The data for the request.
     * @param data.redirectUri
     * @throws ApiError
     */
    public static googleLogin(data: GoogleLoginData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/auth/google',
            query: {
                redirectUri: data.redirectUri
            },
            errors: {
                302: 'Redirect to Google OAuth',
                400: ''
            }
        });
    }
    
    /**
     * Handle Google OAuth callback
     * @throws ApiError
     */
    public static googleLoginCallback(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/auth/google/callback',
            errors: {
                302: 'Redirect to front-end app with JWT',
                400: '',
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * Get a JWT v2 from a v1
     * @returns UpgradeFromJwtV1Response
     * @throws ApiError
     */
    public static upgradeFromJwtV1(): CancelablePromise<UpgradeFromJwtV1Response2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/auth/upgrade-from-v1',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Get an api key from a jwt v1
     * @param data The data for the request.
     * @param data.requestBody
     * @returns UpgradeToApiKeyResponse
     * @throws ApiError
     */
    public static upgradeToApiKey(data: UpgradeToApiKeyData): CancelablePromise<UpgradeToApiKeyResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/auth/upgrade-to-api-key',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Check if an email is available for registration
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CheckEmailAvailabilityResponse
     * @throws ApiError
     */
    public static checkEmailAvailability(data: CheckEmailAvailabilityData): CancelablePromise<CheckEmailAvailabilityResponse2> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/auth/check-email',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Change password
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static changePassword(data: ChangePasswordData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/user/change-password',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Send reset password mail
     * @param data The data for the request.
     * @param data.email
     * @param data.redirectUri
     * @throws ApiError
     */
    public static sendResetPassword(data: SendResetPasswordData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/user/forgot-password/{email}',
            path: {
                email: data.email
            },
            query: {
                redirectUri: data.redirectUri
            },
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * Reset password
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static resetPassword(data: ResetPasswordData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/user/reset-password',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: ''
            }
        });
    }
    
}

export class UsersController {
    /**
     * Get the authenticated user
     * @returns User
     * @throws ApiError
     */
    public static getAuthenticatedUser(): CancelablePromise<GetAuthenticatedUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/user',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Update the authenticated user
     * @param data The data for the request.
     * @param data.requestBody
     * @returns User
     * @throws ApiError
     */
    public static updateAuthenticatedUser(data: UpdateAuthenticatedUserData): CancelablePromise<UpdateAuthenticatedUserResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/user',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * List receipts for the authenticated user
     * @returns UserReceipt
     * @throws ApiError
     */
    public static getUserReceipts(): CancelablePromise<GetUserReceiptsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/user/receipts',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Change password
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static changePassword(data: ChangePasswordData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/user/change-password',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: ''
            }
        });
    }
    
    /**
     * Send reset password mail
     * @param data The data for the request.
     * @param data.email
     * @param data.redirectUri
     * @throws ApiError
     */
    public static sendResetPassword(data: SendResetPasswordData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/user/forgot-password/{email}',
            path: {
                email: data.email
            },
            query: {
                redirectUri: data.redirectUri
            },
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * Reset password
     * @param data The data for the request.
     * @param data.requestBody
     * @throws ApiError
     */
    public static resetPassword(data: ResetPasswordData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/user/reset-password',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: ''
            }
        });
    }
    
}

export class TillsController {
    /**
     * Get the organization tills
     * @param data The data for the request.
     * @param data.organizationId
     * @returns TillsByPointOfSale
     * @throws ApiError
     */
    public static getOrganizationTills(data: GetOrganizationTillsData): CancelablePromise<GetOrganizationTillsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/organizations/{organizationId}/tills',
            path: {
                organizationId: data.organizationId
            },
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Get the point of sale's tills
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @returns Till
     * @throws ApiError
     */
    public static getPointOfSaleTills(data: GetPointOfSaleTillsData): CancelablePromise<GetPointOfSaleTillsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/points-of-sale/{pointOfSaleId}/tills',
            path: {
                pointOfSaleId: data.pointOfSaleId
            },
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Register a till for a point of sale
     * @param data The data for the request.
     * @param data.pointOfSaleId
     * @param data.requestBody
     * @returns CreateTillResponse
     * @throws ApiError
     */
    public static addTill(data: AddTillData): CancelablePromise<AddTillResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/points-of-sale/{pointOfSaleId}/tills',
            path: {
                pointOfSaleId: data.pointOfSaleId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Claim the last receipt of a till
     * @returns ClaimReceiptResponse
     * @throws ApiError
     */
    public static claimTillDemoReceipt(): CancelablePromise<ClaimTillDemoReceiptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tills/demo/claim-last-receipt',
            errors: {
                403: '',
                409: ''
            }
        });
    }
    
    /**
     * Claim the last receipt of a till
     * @param data The data for the request.
     * @param data.tillId
     * @param data.code
     * @returns ClaimReceiptResponse
     * @throws ApiError
     */
    public static claimTillLastReceipt(data: ClaimTillLastReceiptData): CancelablePromise<ClaimTillLastReceiptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tills/{tillId}/claim-last-receipt',
            path: {
                tillId: data.tillId
            },
            query: {
                code: data.code
            },
            errors: {
                403: '',
                409: ''
            }
        });
    }
    
    /**
     * Envoyer un ticket
     * @param data The data for the request.
     * @param data.tillId Identifiant unique de la caisse
     * @param data.xApiKey Clé d'API de la caisse
     * @param data.requestBody
     * @returns ReceiptDetails
     * @throws ApiError
     */
    public static addTillReceipt(data: AddTillReceiptData): CancelablePromise<AddTillReceiptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/tills/{tillId}/receipts',
            path: {
                tillId: data.tillId
            },
            headers: {
                'X-API-Key': data.xApiKey
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Update software metadata for a till
     * @param data The data for the request.
     * @param data.tillId
     * @param data.xApiKey
     * @param data.requestBody
     * @returns Till
     * @throws ApiError
     */
    public static updateSoftwareMetadata(data: UpdateSoftwareMetadataData): CancelablePromise<UpdateSoftwareMetadataResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/tills/{tillId}/software-metadata',
            path: {
                tillId: data.tillId
            },
            headers: {
                'X-API-Key': data.xApiKey
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * Get the corresponding till for an api key
     * @param data The data for the request.
     * @param data.xApiKey
     * @returns TillInfo
     * @throws ApiError
     */
    public static getTillByApiKey(data: GetTillByApiKeyData): CancelablePromise<GetTillByApiKeyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/till',
            headers: {
                'X-API-Key': data.xApiKey
            },
            errors: {
                401: '',
                403: ''
            }
        });
    }
    
    /**
     * Get till api key
     * @param data The data for the request.
     * @param data.tillId
     * @returns ApiKey
     * @throws ApiError
     */
    public static getTillApiKey(data: GetTillApiKeyData): CancelablePromise<GetTillApiKeyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/tills/{tillId}/api-key',
            path: {
                tillId: data.tillId
            },
            errors: {
                401: '',
                404: ''
            }
        });
    }
    
    /**
     * Revoke till api key
     * @param data The data for the request.
     * @param data.tillId
     * @returns ApiKey
     * @throws ApiError
     */
    public static revokeTillApiKey(data: RevokeTillApiKeyData): CancelablePromise<RevokeTillApiKeyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/tills/{tillId}/api-key',
            path: {
                tillId: data.tillId
            },
            errors: {
                401: '',
                404: ''
            }
        });
    }
    
    /**
     * Renew till api key
     * @param data The data for the request.
     * @param data.tillId
     * @returns ApiKey
     * @throws ApiError
     */
    public static renewTillApiKey(data: RenewTillApiKeyData): CancelablePromise<RenewTillApiKeyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/tills/{tillId}/api-key/renew',
            path: {
                tillId: data.tillId
            },
            errors: {
                401: '',
                404: ''
            }
        });
    }
    
    /**
     * Get a till details
     * @param data The data for the request.
     * @param data.tillId
     * @returns TillDetails
     * @throws ApiError
     */
    public static getTillById(data: GetTillByIdData): CancelablePromise<GetTillByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/tills/{tillId}',
            path: {
                tillId: data.tillId
            },
            errors: {
                401: '',
                404: ''
            }
        });
    }
    
    /**
     * Update a till
     * @param data The data for the request.
     * @param data.tillId
     * @param data.requestBody
     * @returns Till
     * @throws ApiError
     */
    public static updateTill(data: UpdateTillData): CancelablePromise<UpdateTillResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/tills/{tillId}',
            path: {
                tillId: data.tillId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: '',
                403: '',
                404: ''
            }
        });
    }
    
}

export class FeatureFlagsController {
    /**
     * @returns FeatureFlag
     * @throws ApiError
     */
    public static findAllFeatureFlags(): CancelablePromise<FindAllFeatureFlagsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/feature-flags'
        });
    }
    
}